<template>
  <div class="doc-view">
    <table style="width:100%;margin-top:40px;">
      <tr>
        <td style="width:400px;vertical-align:top;">
          <div style="margin-top:40px;font-size:20px;font-weight:bold;">
            Cystron Technology Limited
          </div>
          <div style="margin-top:6px;">
            10/F Kras Asia Industrial Building 79 Hung To Road, Kwun Tong, Kowloon, Hong Kong<br/>
            <!-- 
            Tel:&nbsp;852-35952155&nbsp;&nbsp;Fax:&nbsp;852-35952165<br/>
            -->
            http://www.cystrontech.com&nbsp;&nbsp;<br/>
            Email:&nbsp;enquiry@cystrontech.com
          </div>
        </td>
        <td style="width:180px">&nbsp;</td>
        <td>
          <div style="text-align:center;">
            <img alt="cystron" src="~@/assets/logo.png" style="width:149px;height:59px;" />
          </div>
          <div style="font-size:20px;font-weight:bold;text-align:center;">
            <span v-if="doc.is_confirm === '0'">Proforma </span>Invoice
          </div>
          <table style="margin-top:10px;width:100%;border-top:1px solid #000;border-left:1px solid #000;">
            <tr>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">Date</td>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">Invoice Number</td>
            </tr>
            <tr>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">{{ doc.doc_date | engDate }}</td>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">CYS{{ doc.id }}</td>
            </tr>
          </table>
          <div>
            Sales:&nbsp;{{ doc.sales_name.split(' ')[0] }}<br/>
            Tel:&nbsp;86-755-85241971
          </div>
        </td>
      </tr>
    </table>
    <table style="width:100%;margin-top:20px;margin-bottom:20px;">
      <tr>
        <td style="width:385px;border:1px solid #000;font-weight:bold;padding:4px;background-color:#ccc;">Buyer:</td>
        <td rowspan="2" style="width:10px;"></td>
        <td style="border:1px solid #000;font-weight:bold;padding:4px;background-color:#ccc;">Ship To:</td>
      </tr>
      <tr>
        <td style="vertical-align:top;padding:4px;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000;font-size:14px;">
          <strong>{{ doc.company_name }}</strong><br/>
          <span v-html="doc.company_address_br"></span><br/><br/>
          Tel:&nbsp;{{ doc.contact_phone }}&nbsp;&nbsp;<span v-if="doc.contact_fax">Fax:</span>&nbsp;{{ doc.contact_fax }}<br/>
          Attn:&nbsp;{{ doc.contact_name }}<br/><br/>
        </td>
        <td style="vertical-align:top;padding:4px;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000;font-size:14px;">
          <div v-if="doc.shipping_company_name"><strong>{{ doc.shipping_company_name }}</strong></div>
          <div v-html="doc.shipping_address_br"></div>
        </td>
      </tr>
    </table>
    <table class="detail-table" style="border-top:1px solid #000;margin-top:10px;">
      <tr>
        <th>Buyer PO No.</th>
        <th>Payment Terms</th>
        <th>Forwarder</th>
        <th>Delivery Date</th>
      </tr>
      <tr>
        <td>{{ doc.customer_no }}</td>
        <td>{{ doc.payment_terms }}</td>
        <td>{{ doc.forwarder }}</td>
        <td>{{ doc.delivery_date | engDate }}</td>
      </tr>
    </table>
    <table class="detail-table" style="border-top:1px solid #000;margin-top:10px;">
      <tr>
        <th>No.</th>
        <th style="text-align:left;">Part Number</th>
        <th style="text-align:left;">Description</th>
        <th style="text-align:left;">Brand</th>
        <th style="width:50px;">Qty(PCS)</th>
        <th style="width:80px;">Unit Price</th>
        <th style="width:80px;">Amount</th>
      </tr>
      <template  v-for="(item, index) in productList">
        <tr :key="item.id + '1'">
          <td style="border-bottom:0;">{{ item.order_no }}</td>
          <td style="text-align:left;">{{ item.part_no }}</td>
          <td style="text-align:left;">{{ item.description }}</td>
          <td style="text-align:left;">{{ item.brand }}</td>
          <td style="text-align:right;">{{ item.qty | 1000 }}</td>
          <td style="text-align:right;">{{ doc.currency }}{{ item.price | 1000 }}</td>
          <td style="text-align:right;">{{ doc.currency }}{{ item.amount | 1000 }}</td>
        </tr>
        <tr :key="item.id + '2'">
          <td>&nbsp;</td>
          <td colspan="6" style="text-align:left;font-size:13px;" v-html="item.remark_br"></td>
        </tr>
      </template>
      <tr v-if="doc.insurance_charge > 0">
        <td colspan="4">&nbsp;</td>
        <td colspan="2" style="text-align:right;padding-right:4px;">Insurance Charge</td>
        <td style="text-align:right;">{{ doc.currency }}{{ doc.insurance_charge | 1000 }}</td>
      </tr>
      <tr v-if="doc.delivery_charge > 0">
        <td colspan="4">&nbsp;</td>
        <td colspan="2" style="text-align:right;padding-right:4px;">Delivery Charge</td>
        <td style="text-align:right;">{{ doc.currency }}{{ doc.delivery_charge | 1000 }}</td>
      </tr>
      <tr v-if="doc.other_charge > 0">
        <td colspan="4">&nbsp;</td>
        <td colspan="2" style="text-align:right;padding-right:4px;">Other Charge</td>
        <td style="text-align:right;">{{ doc.currency }}{{ doc.other_charge | 1000 }}</td>
      </tr>
      <tr v-if="doc.remarks">
        <td colspan="7" style="border-top:1px solid #000;border-left:1px solid #000;border-bottom:2px solid #000;border-right:2px solid #000;">
          <div flex style="font-weight:bold;">
            <div>Remarks:&nbsp;</div>
            <div v-html="doc.remarks_br" style="text-align:left;"></div>
          </div>
          <br/>
        </td>
      </tr>
      <tr>
        <td colspan="4">&nbsp;</td>
        <td colspan="2" style="text-align:right;padding-right:4px;font-weight:bold;">Total</td>
        <td style="text-align:right;font-weight:bold;">{{ doc.currency }}{{ doc.total_charge | 1000 }}</td>
      </tr>
      <tr v-if="doc.currency !== 'USD'" class="no-print">
        <td colspan="4">&nbsp;</td>
        <td colspan="2" style="text-align:right;padding-right:4px;font-weight:bold;">USD/{{ doc.currency }}:{{ doc.currency_rate }}</td>
        <td style="text-align:right;font-weight:bold;">USD{{ doc.total_charge_usd | 1000 }}</td>
      </tr>
    </table>
    <div style="margin-top:20px;">
      <div style="border:1px solid #000;font-weight:bold;padding:4px;background-color:#ccc;">Banker's Information:</div>
      <div style="padding:4px;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000;" v-html="doc.terms_br"></div>
    </div>
    <table style="width:100%;margin-top:20px;">
      <tr>
        <td style="width:500px;vertical-align: top;">
          <br/>
          Confirmed by<br/><br/><br/><br/><br/><br/>
          __________________________<br/>
          Authorized Signature with Company Chop<br/><br/>
        </td>
        <td style="vertical-align: top;">
          For and on behalf of<br/>
          Cystron Technology Limted<br/><br/><br/><br/><br/><br/>
          _________________________<br/>
          Signature and chop<br/>
          {{ doc.sales_name.split(' ')[0] }}<br/>
          <el-button type="info" class="no-print" style="position:relative;left:10px;top:-90px;" @click="gz('1')" v-if="doc.gz_type === '0'">盖章中</el-button>
          <el-button type="info" class="no-print" style="position:relative;left:10px;top:-90px;" @click="gz('2')" v-if="doc.gz_type === '0'">盖章英</el-button><br/>
          <img alt="cystron" src="//erp.cystrontech.com/oss/1567090153228.png" style="position:relative;left:40px;top:-150px;width:100px;height:100px;" v-if="doc.gz_type === '1'" @click="gz('0')" />
          <img alt="cystron" src="//erp.cystrontech.com/oss/1567090149325.png" style="position:relative;left:40px;top:-150px;width:100px;height:100px;" v-if="doc.gz_type === '2'" @click="gz('0')" />
        </td>
      </tr>
    </table>
    <div class="no-print" :style="{ padding: '40px', textAlign: 'center', marginTop: doc.gz_type === '0' ? 0 : '-95px' }">
      <el-button @click="print">Print</el-button><br/><br/>
      <el-button @click="toDN">To Delivery Note</el-button>
      <el-button @click="toPK">To Packing List</el-button>
    </div>
    <div v-if="doc.is_del === '1'" style="position:fixed;z-index:998;top:0;bottom:0;left:0;right:0;background-color:#999;opacity:0.6;font-weight:bold;font-size:40px;text-align:center;color:red;padding-top:400px;">Void</div>
  </div>
</template>
<script>
import NP from 'number-precision'
export default {
  data () {
    return {
      doc: {},
      productList: [],
      totalCharge: 0
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$http.get('/dbapi/pi_doc_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.doc = data.list[0]
        } else {
          this.$message({
            type: 'error',
            message: data.message
          })
        }
      })
      this.$http.get('/dbapi/pi_doc_details?id=' + this.$route.params.id).then(data => {
        this.productList = data.list
        this.totalCharge = 0
        for (let i = 0; i < this.productList.length; i++) {
          this.totalCharge = NP.plus(this.totalCharge, parseFloat(this.productList[i].amount))
        }
      })
    },
    print () {
      window.print()
    },
    gz (type) {
      this.doc.gz_type = type
      this.$http.post('/dbapi/pi_doc_gz_type', { id: this.$route.params.id, gz_type: type })
    },
    toDN () {
      this.$open('/doc-dn-edit/new?doc_no=pi' + this.$route.params.id, 1000)
    },
    toPK () {
      this.$open('/doc-pk-edit/new?doc_no=pi' + this.$route.params.id, 1000)
    }
  }
}
</script>

<style lang="scss">
.doc-view {
  font-family: "Times New Roman";
  padding: 10px;
  font-size: 14px;
  width: 780px;
  margin: 0 auto;
  background-color:#fff;
  -webkit-print-color-adjust: exact;
  table {
    border-spacing: 0;
  }
  .detail-table {
    border-spacing: 0;
    width: 100%;
    border-left: 1px solid #000;
    th {
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      background-color: #ccc;
    }
    td {
      font-size: 14px;
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  }
}
</style>
